<template>
	<div class="header" ref="header">
		<div class="w1200 head-ctn">
			<div class="logo"><img src="../static/img/logo.png" ></div>
			<ul class="nav">
				<li :class="{act:navActive(item)}" v-for="(item,index) in navList" :key="item.columnId"
					@click="navGo(item)">{{item.columnName}}</li>
			</ul>
		</div>
	</div>
</template>

<script>
export default {
	name: 'mHeader',
	data () {
		return {
			
		}
	},

	computed:{
		navList(){
			//console.log('this.$store.state.navList',this.$store.state.navList)
		 //  if (Array.isArray(this.$store.state.navList) && this.$store.state.navList.length > 0) {
			// let r = []
			// // 删除“新闻动态 100202”与“关于我们 100205”栏目
			// r = this.$store.state.navList.filter(item => item.columnCode !== 100202 && item.columnCode !== 100205)
			// return r
		 //  } else {
			// return []
		 //  }
			return this.$store.state.navList
		},
		nowNavCode(){
			return this.$store.state.nowNavCode
		},
		nowNavId(){
			return this.$store.state.nowNavId
		},
	},

	mounted () {
		//获取底部高度
		setTimeout(()=>{
			this.$store.commit('changeHeadHeight',this.$refs.header.offsetHeight)
		},500)
	},

	watch:{
		$route(to,from){
			const { code } = to.meta
			this.$store.commit('changeNavCode',code)
		}
	},

	methods:{

		//导航页面跳转
		navGo(item){
			let url = ''
			switch(item.columnCode){
				case 1001: url = '/index'; break;		//首页
				case 100203: url = '/course'; break;	//课程中心
				case 100204: url = '/colleges'; break;		//合作院校
				case 100205:
					url = { name:'about',query:{ firstCateId:item.columnId }}
					break;		//关于我们
				default: 	//栏目页
					url = { name:'news',params:{ firstCateId:item.columnId }	}
			}
			this.goUrl(url)
		},

		//计算选中
		navActive(item){
			let isAct = false
			if(this.nowNavCode==-1){	//栏目页
				isAct = item.columnId == this.nowNavId
			}else{
				isAct = (this.nowNavCode == item.columnCode)
			}
			//console.log('this.nowNavId:',this.nowNavId,'this.nowNavCode:',this.nowNavCode)
			return isAct
		},

	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.header{
	height: 64px; background: #FFFFFF; box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.15);
	.head-ctn{
		display:flex; justify-content: space-between; align-items: center; height: 64px; background: #FFFFFF;
		.logo{
			font-size:20px; color:#333333; font-weight: bold; display:flex; align-items: center;
			img{ height:36px; }
		}
		.nav{
			display:flex;
			li{
				display:inline-flex; align-items: center; justify-content: center; height:64px; position:relative; min-width:50px; margin:0 30px;
				font-size:14px; color:#333333; font-weight: bold; cursor: pointer;
				&:hover{ color:#1677FF; }
				&.act{
					color:#1677FF;
					&::after{
						content:''; display:block; width:50px; height:4px; border-radius:2px; background:#1677FF;
						position:absolute; bottom:0; left:50%; margin-left:-25px;
					}
				}
			}
		}
	}

}
</style>



// WEBPACK FOOTER //
// src/components/header.vue